import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveExcludeVariables, GetExcludeVariables } from './index';

// Api's
import { integrationPropertyFilterApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getExcludeVariablesSaga(action: GetExcludeVariables) {
  try {
    const response: AxiosResponse<Result<string[]>> = yield call(
      integrationPropertyFilterApi.getDomain,
      action.payload.request
    );
    if (response.data.result) {
      const keyValueList: KeyValue[] = response.data.result.map(
        (item: string) => ({
          key: item,
          value: item
        })
      );

      yield put(
        saveExcludeVariables(
          keyValueList,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveExcludeVariables(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

